import { SubtitlesErrorModel } from '../models/file/file-error.model';
import { FileRequirementsBase } from '../models/file/file-requirements.model';

import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { SubtitlesConfig } from '../models';

const subtitlesRequirements: FileRequirementsBase = {
    acceptedFileType: '.vtt',
};

const subtitlesErrors: SubtitlesErrorModel[] = [
    {
        id: 'extension',
        text: marker('v3-file-uploader-extension-are-allowed'),
        extensions: [marker('v3-global-vtt')],
    },
    {
        id: 'virus',
        text: marker('v3-file-uploader-virus-warning'),
    },
    {
        id: 'size',
        text: marker('v3-subtitles-uploader-max-size-warning'),
    },
    {
        id: 'storage',
        text: marker('v3-file-uploader-video-storage-warning'),
        value: marker('v3-global-GB'),
    },
];

export const subtitlesConfig: SubtitlesConfig = {
    requirements: subtitlesRequirements,
    errors: subtitlesErrors,
    validateUrl: 'api/v2.5/manager/content/builder/upload-content/validate/custom/subtitles',
    icon: 'document',
    canPreview: false,
};
